import React from "react";
import { BrowserRouter as Router, Routes, Route, useLocation, useNavigate } from "react-router-dom";

import { Home, ChatWithMe, NotFound, Admin, Resume } from "./pages";
import { Navbar } from "./components";
import { DataProvider } from "./contexts/DataContext";
import { DarkModeProvider } from "./contexts/DarkModeContext";
import "./App.scss";

const BackToResumePill = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const isChat = location.pathname === '/chat';
  const isResume = location.pathname === '/resume';

  // Set sessionStorage when ?from=resume is in the URL
  const fromParam = new URLSearchParams(location.search).get('from') === 'resume';
  if (fromParam) sessionStorage.setItem('fromResume', '1');

  const showPill = sessionStorage.getItem('fromResume') === '1' && !isChat && !isResume;

  if (!showPill) return null;

  return (
    <button
      className="app__back-resume-pill"
      onClick={() => {
        sessionStorage.removeItem('fromResume');
        navigate('/resume');
      }}
    >
      ← Back to Resume
    </button>
  );
};

// Navbar wrapper component that conditionally renders navbar
const ConditionalNavbar = () => {
  const location = useLocation();
  
  // Don't show navbar on admin or home page
  if (location.pathname === '/' || location.pathname === '/admin') {
    return location.pathname === '/' ? <Navbar /> : null;
  }
  
  return null;
};

// Component that contains the app content inside Router context
const AppContent = () => {
  return (
    <div className="app">
      <ConditionalNavbar />
      <BackToResumePill />
      <Routes>
        {/* Main routes */}
        <Route path="/" element={<Home />} />
        <Route path="/chat" element={<ChatWithMe />} />
        
        {/* Hidden admin route */}
        <Route path="/admin" element={<Admin />} />
        
        {/* Resume page */}
        <Route path="/resume" element={<Resume />} />
        
        {/* 404 page */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </div>
  );
};

const App = () => {
  return (
    <DarkModeProvider>
      <DataProvider>
        <Router>
          <AppContent />
        </Router>
      </DataProvider>
    </DarkModeProvider>
  );
};

export default App;
